import { InjectionToken } from '@angular/core';

export const ORDERS_API_TOKEN: InjectionToken<string> = new InjectionToken(
  'ORDERS_API',
);

export const ORDERS_V2_API_TOKEN: InjectionToken<string> = new InjectionToken(
  'ORDERS_V2_API',
);

export const ORDERS_FILTERS_V2_API_TOKEN: InjectionToken<string> =
  new InjectionToken('ORDERS_FILTERS_V2_API_TOKEN');

export const ORDERS_CONFIGURATION_API_TOKEN = new InjectionToken<string>(
  'Order config API',
);

export const AGGREGATIONS_API_TOKEN: InjectionToken<string> =
  new InjectionToken('Aggregations API');
